import { notification } from "antd";
import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
import { supabase } from "@/utils/supabase";
export class SingleTechnicianStore {
    constructor(technicianService) {
        this.technicianService = technicianService;
        this.technician = null;
        this.loading = false;
        makeAutoObservable(this);
    }
    setTechnician(technician) {
        this.technician = technician;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async init(technicianId) {
        this.setLoading(true);
        try {
            const technicians = technicianId
                ? await this.technicianService.getTechniciansByIds([technicianId])
                : null;
            this.setTechnician(technicians?.[0] || null);
        }
        catch (error) {
            onError(error, "Error initializing technician");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveTechnician(technicianData, password) {
        try {
            this.setLoading(true);
            const task = this.technician
                ? this.technicianService.updateTechnician(this.technician.id, technicianData)
                : this.technicianService.createTechnician(technicianData);
            this.setTechnician(await task);
            if (password && this.technician) {
                await this.setEmployeePassword(this.technician.id, password);
            }
            return this.technician;
        }
        catch (error) {
            onError(error, "Error saving technician");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async setEmployeePassword(employeeId, password) {
        try {
            const { data, error } = await supabase().functions.invoke("set-employee-password", {
                body: { employeeId, password },
            });
            if (error) {
                throw error;
            }
            if (data?.error) {
                notification.warning({
                    message: "Пароль не полностью синхронизирован",
                    description: data.error,
                });
                return;
            }
            notification.success({ message: "Пароль успешно обновлён" });
        }
        catch (error) {
            onError(error, "Ошибка синхронизации пароля");
            // Не бросаем ошибку дальше — сотрудник уже сохранён
        }
    }
    async deleteTechnician(technicianId) {
        this.setLoading(true);
        try {
            await this.technicianService.deleteTechnician(technicianId);
            this.setTechnician(null);
        }
        catch (error) {
            onError(error, "Failed to delete technician");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearTechnicianData() {
        this.setTechnician(null);
        this.setLoading(false);
    }
}
